import "./App.css";
import AppRoute from "./route/Approute";

function App() {
  return (
    <>
      <AppRoute />
    </>
  );
}

export default App;
